/* Rolagem suave e lenta para as âncoras internas das landings de kit ("Montar Kit
   Personalizado" do hero e do CTA → #monte-seu-kit). O `scroll-behavior: smooth` nativo
   do tema é rápido demais e não deixa escolher duração nem curva; aqui a animação é
   própria, com duração proporcional à distância e easing suave nas duas pontas.
   Desconta a altura do header fixo (sticky "always") para o título da section não ficar
   escondido atrás dele. Com `prefers-reduced-motion`, pula direto, sem animar.
   Carregado pelas sections kit-hero e kit-cta; o guard evita dois listeners. */
(() => {
  if (window.FoxTheme?.kitRolagem) return;
  window.FoxTheme = window.FoxTheme || {};
  window.FoxTheme.kitRolagem = true;

  const DURACAO_MIN = 900;
  const DURACAO_MAX = 1600;
  const MS_POR_PX = 0.6;
  const FOLGA = 16;

  const suavizar = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);

  function alturaDoHeader() {
    const header = document.querySelector('header[is="sticky-header"]');
    return header ? header.getBoundingClientRect().height : 0;
  }

  let animacao = null;

  function rolarAte(alvo) {
    const inicio = window.scrollY;
    const destino = Math.max(0, alvo.getBoundingClientRect().top + inicio - alturaDoHeader() - FOLGA);
    const distancia = destino - inicio;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || Math.abs(distancia) < 2) {
      window.scrollTo({ top: destino, behavior: 'instant' });
      return;
    }

    const duracao = Math.min(DURACAO_MAX, Math.max(DURACAO_MIN, Math.abs(distancia) * MS_POR_PX));
    const t0 = performance.now();
    if (animacao) cancelAnimationFrame(animacao);

    // O usuário assume a rolagem (roda, toque, tecla) → a animação para onde está.
    const cancelar = () => {
      if (animacao) cancelAnimationFrame(animacao);
      animacao = null;
      removerCancelamento();
    };
    const eventos = ['wheel', 'touchstart', 'keydown'];
    const removerCancelamento = () => eventos.forEach((e) => window.removeEventListener(e, cancelar));
    eventos.forEach((e) => window.addEventListener(e, cancelar, { passive: true }));

    const passo = (agora) => {
      const t = Math.min(1, (agora - t0) / duracao);
      window.scrollTo({ top: inicio + distancia * suavizar(t), behavior: 'instant' });
      if (t < 1) {
        animacao = requestAnimationFrame(passo);
      } else {
        animacao = null;
        removerCancelamento();
      }
    };
    animacao = requestAnimationFrame(passo);
  }

  document.addEventListener('click', (evento) => {
    if (evento.defaultPrevented || evento.button !== 0 || evento.metaKey || evento.ctrlKey || evento.shiftKey) return;
    const link = evento.target.closest('.kit-base a[href^="#"]');
    if (!link) return;
    const id = decodeURIComponent(link.getAttribute('href').slice(1));
    const alvo = id && document.getElementById(id);
    if (!alvo) return;

    evento.preventDefault();
    rolarAte(alvo);
    history.pushState(null, '', `#${id}`);
  });
})();
